var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.idModal,"static":true,"hide-footer":"","centered":""},scopedSlots:_vm._u([{key:"modal-header",fn:function(){return [_c('ButtonClose',{attrs:{"modal-name":_vm.idModal}})]},proxy:true}])},[_vm._v(" "),_c('Menu',{staticClass:"d-block d-xl-none p-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }